import React from "react";
import "../Services/Services.css";

const OurServicesPreview = ({ previewService, setShowPreviewOurService }) => {
    const service = previewService;

    if (!service) return null;

    return (
        <div className="service-preview-overlay" onClick={() => setShowPreviewOurService(false)}>
            <div className="service-preview-modal" onClick={(e) => e.stopPropagation()}>

                <button className="service-preview-close" onClick={() => setShowPreviewOurService(false)}>
                    ✕
                </button>

               
                <div className="service-preview-header">
                    <h1>Services</h1>
                    <p>Home &gt; <span className="about-preview-subtitle">{service.heading}</span></p>
                </div>

            
                <h2 className="service-preview-title">{service.heading}</h2>

            
                <div className="service-preview-content">

                    <div className="service-preview-image-wrapper">
                        <img src={service.image} alt={service.heading} />
                    </div>

                    <div className="service-preview-text">

                        <h3 className="sp-subtitle">Description</h3>
                        <div
                            className="service-preview-description"
                            dangerouslySetInnerHTML={{ __html: service.description }}
                        />

                        <h3 className="sp-subtitle mt-30">Requirements</h3>
                        <div
                            className="service-preview-description"
                            dangerouslySetInnerHTML={{ __html: service.requirements }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurServicesPreview;
